import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=28de5998&scoped=true&"
import script from "./Empty.vue?vue&type=script&lang=js&"
export * from "./Empty.vue?vue&type=script&lang=js&"
import style0 from "./Empty.vue?vue&type=style&index=0&id=28de5998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28de5998",
  null
  
)

export default component.exports